import styled from "styled-components";
import { handleLink } from "../utils/handleLink";
import FadeInItem from "./FadeInItem";

const Reservation = () => {
  return (
    <FadeInItem point={0.25}>
      <Wrapper>
        <div>
          <div>
            <img
              onClick={() =>
                handleLink(
                  "http://www.cgv.co.kr/culture-event/event/defaultNew.aspx#1"
                )
              }
              src="/assets/logo_cgv.png"
              alt="linkToCgv"
            ></img>
            <img
              onClick={() => handleLink("https://megabox.co.kr/event")}
              src="/assets/logo_mega.png"
              alt="linkToMega"
            ></img>
            <img
              onClick={() =>
                handleLink("https://event.lottecinema.co.kr/NLCHS/Event")
              }
              src="/assets/logo_lotte.png"
              alt="linkToLotte"
            ></img>
            <img
              onClick={() => handleLink("https://www.cineq.co.kr/Event/List")}
              src="/assets/logo_cineq.png"
              alt="linkToCineq"
            ></img>
          </div>
          <div>
            <ReservationLink
              onClick={() => handleLink("http://cgv.kr/Gp7g4FZe")}
            >
              일반예매
            </ReservationLink>
            <ReservationLink
              onClick={() => handleLink("https://bit.ly/3xXQpUs")}
            >
              일반예매
            </ReservationLink>
            <ReservationLink
              onClick={() => handleLink("https://bit.ly/4cViV7S")}
            >
              일반예매
            </ReservationLink>
            <ReservationLink
              onClick={() => handleLink(" https://bit.ly/4ddtwLQ")}
            >
              일반예매
            </ReservationLink>
          </div>
        </div>
      </Wrapper>
      <Description></Description>
    </FadeInItem>
  );
};

export default Reservation;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  padding-bottom: 50px;

  > div {
    width: 74%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;

    > div {
      width: 100%;
      display: grid;
      grid-gap: 24px;
      grid-template-columns: repeat(4, 1fr);

      > div {
        justify-self: center;
      }
    }
  }

  img {
    cursor: pointer;
    max-width: 240px;
    object-fit: contain;
    transition: max-width 0.3s ease 0s;
    justify-self: center;

    @media only screen and (max-width: 1200px) {
      width: 80%;
    }

    @media only screen and (max-width: 600px) {
      margin-bottom: 12px;
      max-width: 96px;
    }
  }

  @media only screen and (max-width: 1150px) {
    padding-bottom: 6%;

    > div {
      width: 94%;
      gap: 24px;

      > div {
        grid-gap: 8px;
      }
    }
  }

  @media only screen and (max-width: 600px) {
    padding-bottom: 30px;

    > div {
      gap: 12px;
    }
  }
`;

const Description = styled.div`
  text-align: center;
  font-size: 2.4rem;
  color: var(--primary);
  line-height: 60px;
  word-break: keep-all;
  padding: 0 0 240px;

  > p:first-of-type {
    margin-bottom: 8px;
    font-weight: 700;
  }

  > p:last-of-type {
    font-weight: 700;
  }

  @media only screen and (max-width: 1150px) {
    padding: 6% 0 100px;
    font-size: 2.2rem;

    > p:not(:first-of-type) {
      margin-bottom: 20px;
      line-height: 32px;
    }
  }

  @media only screen and (max-width: 800px) {
    span {
      display: block;
      word-break: keep-all;
    }
  }

  @media only screen and (max-width: 480px) {
    padding: 6% 0 80px;
    font-size: 2rem;

    > p:not(:first-of-type) {
      line-height: 24px;
      font-size: 1.8rem;
    }
  }
`;

const Link = styled.div`
  font-weight: 700;
  max-width: 250px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  font-size: 2.4rem;
  word-break: keep-all;
  text-align: center;
  padding: 5px 8px;
  cursor: pointer;

  @media only screen and (max-width: 480px) {
    border-radius: 20px;
  }
`;

const ReservationLink = styled(Link)`
  background: var(--primary);
  color: var(--white);
  padding: 4px 8px;

  @media only screen and (max-width: 1200px) {
    font-size: 1.8rem;
  }

  @media only screen and (max-width: 600px) {
    font-size: 1.6rem;
  }

  @media only screen and (max-width: 480px) {
    font-size: 1.5rem;
  }
`;
